import React from "react";
import { fetchAttachmentURL } from "../../API/api";
import styles from "./AttachmentBoxStyles.module.css";

export const openPreviewAttachment = (file) => {

  let payload = {
    name: file,
  };
  fetchAttachmentURL(payload)
    .then((res) => {
      if (res===undefined) return;
      var response = res.data.data;
      if ((file?.includes(".pdf") ||file?.includes(".PDF") || file?.includes(".Pdf")) && !file?.includes(".pdf_")) {
        response.src = response.src.replace(
          "data:null",
          "data:application/pdf"
        );
      } else {
        response.src = response.src.replace("data:null", "data:image/png");
      }
      fetch(response.src).then(function (res1) {
        res1.blob().then(function (blob) {
          window.open(URL.createObjectURL(blob), "_blank");
        });
      });
    })
    .catch((err) => {});
}

export default function AttachmentBox({ attachment }) {
  const downloadAttachment = (file) => {
    console.log("files",file)
    let payload = {
      name: file,
    };
    console.log("file",payload)
    if(attachment.name?.includes(".docx") || attachment.name?.includes(".doc") || attachment.name?.includes(".xlsx") || attachment.name.includes(".csv")){
      fetchAttachmentURL(payload)
      .then((res) => {
        if (res===undefined) return;
        var response = res.data.data;
            var aTag = document.createElement("a");
            aTag.setAttribute("href", response.objectUrl);
            aTag.setAttribute("download", response.name);
            aTag.click();
      })
      .catch((err) => {});
    }
    else{
      // console.log("value")
      // fetchAttachmentURL(payload)
      // .then((res) => {
      //   if (res===undefined) return;
      //   var response = res.data.data;
      //       var aTag = document.createElement("a");
      //       aTag.setAttribute("href", response.objectUrl);
      //       aTag.setAttribute("download", response.name);
      //       aTag.click();
      // })
      // .catch((err) => {});
      fetchAttachmentURL(payload)
      .then((res) => {
        if (!res) return;
        const { src, name } = res.data.data;
    
        fetch(src)
          .then((res1) => res1.blob())
          .then((blob) => {
            const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = name || "download";
            a.style.display = "none"; // make sure it doesn't flash on screen
            document.body.appendChild(a); // required for Firefox
            a.click();
            document.body.removeChild(a); // clean up
            URL.revokeObjectURL(a.href); // release memory
          });
      })
      .catch((err) => {
        console.error("Download error:", err);
      });
    }
  };

;

  return (
    <>
      {(attachment?.name?.includes(".pdf") ||attachment?.name?.includes(".PDF") || attachment?.name?.includes(".Pdf")) && !attachment?.name?.includes(".pdf_") ? (
        <span className={styles.imageAttachmentContent}>
          <a onClick={() => openPreviewAttachment(attachment.name)}>
            <span
              className="fa fa-file-pdf-o"
              style={{ color: "#e61a0e", fontSize: "14px", padding: "3px" }}
            ></span>
            {attachment.name}
          </a>
          <a>
            <span
              className={styles.downloadIcon}
              onClick={() => downloadAttachment(attachment?.name)}
            >
              <i
                className="fa fa-download attachment-download "
                aria-hidden="true"
                style={{ padding: "3px" }}
              ></i>
            </span>
          </a>
        </span>
      ) : null}
      {attachment.name?.includes(".jpeg") ||
      attachment.name?.includes(".jpg") ||
      attachment.name?.includes(".png") ||
      attachment.name?.includes(".JPEG") ||
      attachment.name?.includes(".JPG") ||
      attachment.name?.includes(".PNG")? (
        <span className={styles.imageAttachmentContent}>
          <a onClick={() => openPreviewAttachment(attachment.name)}>
            <span
              className="fa fa-file-image-o"
              style={{ color: "#e61a0e", fontSize: "14px", padding: "3px" }}
            ></span>
            {attachment.name}
          </a>
          <a>
            <span
              className={styles.downloadIcon}
              onClick={() => downloadAttachment(attachment.name)}
            >
              <i
                className="fa fa-download attachment-download "
                aria-hidden="true"
                style={{ padding: "3px" }}
              ></i>
            </span>
          </a>
        </span>
      ) : null}
      {attachment.name?.includes(".mp4") || attachment.name?.includes(".MP4")|| attachment.name?.includes(".mov") ||attachment.name?.includes(".MOV") ? (
        <span className={styles.imageAttachmentContent}>
          <a style={{ pointerEvents: "none" }}>
            <span
              className="fa fa-file-video-o"
              style={{ color: "#e61a0e", fontSize: "14px", padding: "3px" }}
            ></span>
            {attachment.name}
          </a>
        </span>
      ) : null}
      {attachment.name?.includes(".docx") || attachment.name?.includes(".doc") || attachment.name?.includes(".xlsx") || attachment.name?.includes(".ppt") || attachment.name.includes('.csv') ? (
        <span className={styles.imageAttachmentContent}>
          <a style={{ pointerEvents: "none" }}>
            <span
              className={`${attachment.name?.includes(".docx") || attachment.name?.includes(".doc") ? 'fa fa-file-o':"fa fa-file-excel-o"}`}
              style={{ color: "#e61a0e", fontSize: "14px", padding: "3px" }}
            ></span>
            {attachment.name}
          </a>
          <a>
            <span
              className={styles.downloadIcon}
              onClick={() => downloadAttachment(attachment.name)}
            >
              <i
                className="fa fa-download attachment-download "
                aria-hidden="true"
                style={{ padding: "3px" }}
              ></i>
            </span>
          </a>
        </span>
      ) : null}
    </>
  );
}
